import React from 'react';
import styled from 'styled-components';

const NavButton = styled.button`
    width: 3rem;
    height: 2.2rem;
    border: none;
    display: none;
    flex-direction: column;
    justify-content: space-between;
    background-color: transparent;
    z-index: 99;
    overflow: hidden;

    div {
        background-color: #EB6AA4;
        height: 3px;
        width: 100%;
        transition: 0.3s ease-in-out;
    }

    div:nth-of-type(1) {
        transform: ${({open}) => open ? 'translateY(1rem) rotate(45deg)' : 'none'};
    }
    div:nth-of-type(2) {
        transform: ${({open}) => open ? 'translateX(6rem)' : 'none'};
    }
    div:nth-of-type(3) {
        transform: ${({open}) => open ? 'translateY(-1rem) rotate(-45deg)' : 'none'};
    }

    @media (max-width: 1080px) {
        display: flex;
        
    }

    @media (max-width: 750px) {

    }
`;

const NavBurger = ({open, clickFunc}) => {  

    return (
    <NavButton open={open} onClick={() => clickFunc() }>
        <div></div>
        <div></div>
        <div></div>
    </NavButton>
    )
    }

export default NavBurger